var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgSearchAccepted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.0981445C4.477 0.0981445 0 4.57514 0 10.0981C0 15.6211 4.477 20.0981 10 20.0981C15.523 20.0981 20 15.6211 20 10.0981C20 4.57514 15.523 0.0981445 10 0.0981445ZM15.707 7.80514L8.707 14.8051C8.512 15.0001 8.256 15.0981 8 15.0981C7.744 15.0981 7.488 15.0001 7.293 14.8051L4.293 11.8051C3.902 11.4141 3.902 10.7821 4.293 10.3911C4.684 10.0001 5.316 10.0001 5.707 10.3911L8 12.6841L14.293 6.39114C14.684 6.00014 15.316 6.00014 15.707 6.39114C16.098 6.78214 16.098 7.41414 15.707 7.80514Z",
    fill: "#0BA169"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchAccepted);
export default __webpack_public_path__ + "static/media/search_accepted.6f591885bf51a8002d74868ef0233b2e.svg";
export { ForwardRef as ReactComponent };